import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getInitials(name: string | null | undefined): string {
  if (!name) return "";
  return name
    .split(' ')
    .map((n) => n[0])
    .join('');
}

/**
 * Formats a time string (e.g., "08:00") into a more readable format (e.g., "8:00 AM").
 * @param timeString The time string in HH:mm format.
 * @returns The formatted time string, or the original string if the format is invalid.
 */
export function formatTime(timeString: string | null | undefined): string {
  if (!timeString) {
    return "N/A";
  }

  // Check if the time string is in the expected HH:mm format
  if (!/^\d{2}:\d{2}$/.test(timeString)) {
    return timeString; // Return original string if format is not as expected
  }

  const [hours, minutes] = timeString.split(':');
  const date = new Date();
  date.setHours(parseInt(hours, 10));
  date.setMinutes(parseInt(minutes, 10));
  date.setSeconds(0);

  // Use Intl.DateTimeFormat for robust, locale-aware time formatting
  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }).format(date);
}
